module.exports = __webpack_public_path__ + "static/img/title_05.d3f92476.png";